export const isDev = () => process.env.NODE_ENV === 'development';

export const isLocal = () => process.env.NODE_ENV === 'local';
